<template>
  <div>
    <div class="banner">
      <div class="headerReplacementBasicInfo"></div>
      <div class="banner-text">
        <b>{{ $t('basicInformation.pageTitle') }}</b>
        <div class="breadcrumb">
          <span><router-link to="/" class="pe-auto">{{ $t('basicInformation.breadcrumbHome') }}</router-link></span>
          <span class="separator"></span>
          <span>{{ $t('basicInformation.breadcrumbShareholder') }}</span>
          <span class="separator"></span>
          <span><b>{{ $t('basicInformation.pageTitle') }}</b></span>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="TabMenu">
        <BasicInfoTabMenu />
      </div>
      <table class="table mb-5 mt-5">
        <thead>
          <tr class="table-secondary">
            <th scope="col">
              <h4 class="mt-1">{{ $t('basicInformation.sectionHeader') }}</h4>
            </th>
            <th scope="col"></th>
            <th scope="col"></th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope="row"><b>{{ $t('basicInformation.companyName') }}</b></th>
            <td>{{ $t('basicInformation.companyNameValue') }}</td>
          </tr>
          <tr>
            <th scope="row"><b>{{ $t('basicInformation.stockSymbol') }}</b></th>
            <td>{{ $t('basicInformation.stockSymbolValue') }}</td>
          </tr>
          <tr>
            <th scope="row"><b>{{ $t('basicInformation.businessType') }}</b></th>
            <td>{{ $t('basicInformation.businessTypeValue') }}</td>
          </tr>
          <tr>
            <th scope="row"><b>{{ $t('basicInformation.companyRegistration') }}</b></th>
            <td>{{ $t('basicInformation.companyRegistrationValue') }}</td>
          </tr>
          <tr>
            <th scope="row"><b>{{ $t('basicInformation.registeredShares') }}</b></th>
            <td>{{ $t('basicInformation.registeredSharesValue') }}</td>
          </tr>
          <tr>
            <th scope="row"><b>{{ $t('basicInformation.registeredCapital') }}</b></th>
            <td>{{ $t('basicInformation.registeredCapitalValue') }}</td>
          </tr>
          <tr>
            <th scope="row"><b>{{ $t('basicInformation.paidUpCapital') }}</b></th>
            <td>{{ $t('basicInformation.paidUpCapitalValue') }}</td>
          </tr>
          <tr>
            <th scope="row"><b>{{ $t('basicInformation.shareParValue') }}</b></th>
            <td>{{ $t('basicInformation.shareParValueValue') }}</td>
          </tr>
          <tr>
            <th scope="row"><b>{{ $t('basicInformation.headOffice') }}</b></th>
            <td>{{ $t('basicInformation.headOfficeValue') }}</td>
          </tr>
          <tr>
            <th scope="row"><b>{{ $t('basicInformation.phone') }}</b></th>
            <td>{{ $t('basicInformation.phoneValue') }}</td>
          </tr>
          <tr>
            <th scope="row"><b>{{ $t('basicInformation.fax') }}</b></th>
            <td>{{ $t('basicInformation.faxValue') }}</td>
          </tr>
          <tr>
            <th scope="row"><b>{{ $t('basicInformation.contactAddress') }}</b></th>
            <td>{{ $t('basicInformation.contactAddressValue') }}</td>
          </tr>
          <tr>
            <th scope="row"><b>{{ $t('basicInformation.website') }}</b></th>
            <td><a :href="$t('basicInformation.websiteValue')" target="_blank">{{ $t('basicInformation.websiteValue') }}</a></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>


<script>
import BasicInfoTabMenu from '@/components/BasicInfoTabMenu.vue';

export default {
  name: 'Info',
  components: {
    BasicInfoTabMenu,
  },
  data() {
    return {
    };
  },
  methods: {
  
  },

};
</script>
<style scoped>
th {
  font-weight: normal;
}

.table {
  margin-bottom: 0;
}
</style>
